<template>
    <div class="row-min-space">
        <b-form-group
            id="input-group-1"
            :label="field.label"
            label-for="input-1"
        >
            <div class="row profile-setup">
                <div class="col-md-5 mb-20 dialling-code-field">
                    <isd-code
                        :data-segment-id="dataSegmentId"
                        :field="{
                            association: 'countries',
                            type: 'isd-code',
                            isLocked: true,
                            isRequired: false,
                            label: 'Dialing code',
                            placeholder: 'Dialing code',
                            options: [],
                            key: 'contactInfo.isdCode',
                        }"
                        text-field="isdCodeTitle"
                        value-field="isdCode"
                        :multiple="false"
                        name="Dialing Code"
                    ></isd-code>
                </div>
                <div class="col-md-7">
                    <b-form-input
                        type="number"
                        required
                        autocomplete="no"
                        :placeholder="field.placeholder"
                    ></b-form-input>
                </div>
            </div>
        </b-form-group>
    </div>
</template>

<script>
import IsdCode from '../registration/IsdCode'
import { mapGetters } from 'vuex'
export default {
    components: {
        IsdCode,
    },
    //eslint-disable-next-line
    props: ['field'],

    data() {
        return {
            textField: 'title',
            valueField: '_id',
        }
    },
    computed: {
        ...mapGetters(['dataSegmentId']),
    },
}
</script>
